import type { ReactElement, ReactNode } from 'react';
import { findChildByType, getComponentProps } from '@fiverr-private/ui_utils';
import { TRACK_ID } from '../Track/constants';
import { SLIDES_INDICATOR_ID } from '../SlidesIndicator/constants';
import type { TrackProps } from '../Track/types';
import type { SlidesIndicatorProps } from '../SlidesIndicator/types';

export const getChildren = (children: ReactNode) => {
    const Track = findChildByType(children, TRACK_ID) as ReactElement<TrackProps>;
    const Slides = getComponentProps(Track).children || [];
    const SlidesIndicator = findChildByType(children, SLIDES_INDICATOR_ID) as ReactElement<SlidesIndicatorProps>;

    return { Track, Slides, SlidesIndicator };
};
